import React, { Component } from "react";
import { Card, CardBody, CardHeader, Nav, NavItem, NavLink, TabContent, TabPane, Spinner } from "reactstrap";
import { getGlobalStreamConfigs } from "../services/globalStreamConfigService";
import GlobalTargetRatesForm from "../components/Forms/GlobalTargetRatesForm";
import CashierForm from "../components/Forms/CashierForm";
import "../components/GlobalStreamConfig.scss";

class GlobalStreamConfigView extends Component {
  state = {
    streamConfigs: null,
    activeMainTab: "store", // "store" or "cashier"
  };

  async componentDidMount() {
    await this.fetchGlobalStreamConfigs();
  }

  async fetchGlobalStreamConfigs() {
    const { data: streamConfigs } = await getGlobalStreamConfigs();
    this.setState({ streamConfigs });
  }

  toggleMainTab(tabName) {
    this.setState({ activeMainTab: tabName });
  }

  render() {
    const { streamConfigs, activeMainTab } = this.state;
    const globalTargetRates = streamConfigs?.global?.global_target_rates || {};
    const cashierConfig = {
      fixed_camera_tr: streamConfigs?.global?.cashier?.fixed_camera_tr ?? null,
      deep_model: streamConfigs?.global?.cashier?.deep_model ?? null,
    };

    return (
      <div className="content">
        <Card>
          <CardHeader>
            <h5 className="card-category">Stream configs</h5>
          </CardHeader>
          {!streamConfigs && (
            <CardBody>
              <Spinner color="primary" />
            </CardBody>
          )}
          {streamConfigs && (
            <CardBody>
              {/* Main tabs: Store, Cashier */}
              <Nav tabs className="mb-3">
                <NavItem role="button">
                  <NavLink
                    className={activeMainTab === "store" ? "active" : ""}
                    onClick={() => {
                      this.toggleMainTab("store");
                    }}
                  >
                    Store
                  </NavLink>
                </NavItem>
                <NavItem role="button">
                  <NavLink
                    className={activeMainTab === "cashier" ? "active" : ""}
                    onClick={() => {
                      this.toggleMainTab("cashier");
                    }}
                  >
                    Cashier
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeMainTab}>
                {/* Store Tab */}
                <TabPane tabId="store">
                  <GlobalTargetRatesForm globalTargetRates={globalTargetRates} />
                </TabPane>

                {/* Cashier Tab */}
                <TabPane tabId="cashier">
                  <CashierForm cashierConfig={cashierConfig} onSave={this.fetchGlobalStreamConfigs} />
                </TabPane>
              </TabContent>
            </CardBody>
          )}
        </Card>
      </div>
    );
  }
}

export default GlobalStreamConfigView;
